import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import person1 from '../src/Images/person-1.png'

const Testimonial = () =>{
    return(
        // <!-- Start Testimonial Slider -->
		// <div class="testimonial-section">
		// 	<div class="container">
		// 		<div class="row">
		// 			<div class="col-lg-7 mx-auto text-center">
		// 				<h2 class="section-title">Testimonials</h2>
		// 			</div>
		// 		</div>

		// 		<div class="row justify-content-center">
		// 			<div class="col-12">
		// 				<div class="testimonial-slider-wrap text-center">

		// 					<div id="testimonial-nav">
		// 						<span class="prev" data-controls="prev"><span class="fa fa-chevron-left"></span></span>
		// 						<span class="next" data-controls="next"><span class="fa fa-chevron-right"></span></span>
		// 					</div>

		// 					<div class="testimonial-slider">
            // {/* <OwlCarousel className='owl-theme' loop margin={3} nav> */}


								
								// {/* <div class="item">
								// 	<div class="row justify-content-center">
								// 		<div class="col-12">

								// 			<div class="testimonial-block text-center">
								// 				<blockquote class="mb-5">
								// 					<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
								// 				</blockquote>

								// 				<div class="author-info">
								// 					<div class="author-pic">
								// 						<img src={person1} alt="Maria Jones" class="img-fluid"/>
								// 					</div>
								// 					<h3 class="font-weight-bold">Maria Jones</h3>
								// 					<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
								// 				</div>
								// 			</div>

								// 		</div>
								// 	</div>
								// </div>  */}
								// {/* <!-- END item --> */}

								// {/* <div class="item">
								// 	<div class="row justify-content-center">
								// 		<div class="col-12">

								// 			<div class="testimonial-block text-center">
								// 				<blockquote class="mb-5">
								// 					<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
								// 				</blockquote>

								// 				<div class="author-info">
								// 					<div class="author-pic">
								// 						<img src={person1} alt="Maria Jones" class="img-fluid"/>
								// 					</div>
								// 					<h3 class="font-weight-bold">Maria Jones</h3>
								// 					<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
								// 				</div>
								// 			</div>

								// 		</div>
								// 	</div>
								// </div>  */}
								// {/* <!-- END item --> */}

			// 					{/* <div class="item">
			// 						<div class="row justify-content-center">
			// 							<div class="col-12">

			// 								<div class="testimonial-block text-center">
			// 									<blockquote class="mb-5">
			// 										<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
			// 									</blockquote>

			// 									<div class="author-info">
			// 										<div class="author-pic">
			// 											<img src={person1} alt="Maria Jones" class="img-fluid"/>
			// 										</div>
			// 										<h3 class="font-weight-bold">Maria Jones</h3>
			// 										<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
			// 									</div>
			// 								</div>

			// 							</div>
			// 						</div>
			// 					</div>  */}
			// 					{/* <!-- END item --> */}

            // {/* </OwlCarousel> */}
		// 					</div>

		// 				</div>
		// 			</div>
		// 		</div>
		// 	</div>
		// </div>
		// {/* <!-- End Testimonial Slider --> */}
        <div  class="testimonial-section">
			<div class="container">
			<div class="row">
		 			<div class="col-lg-7 mx-auto text-center">
		 				<h2 class="section-title mb-5">Testimonials</h2>
		 			</div>
		 		</div>

              <OwlCarousel className='owl-theme' loop margin={10} nav>
    <div class='item'>
	<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    <div class='item'>
	<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    <div class='item'>
		<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    <div class='item'>
	<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    <div class='item'>
	<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    <div class='item'>
	<div class="row justify-content-center">
										<div class="col-12">

											<div class="testimonial-block text-center">
												<blockquote class="mb-5">
													<p>&ldquo;Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer convallis volutpat dui quis scelerisque.&rdquo;</p>
												</blockquote>

												<div class="author-info">
													<div class="author-pic">
														<img src={person1} alt="Maria Jones" class="img-fluid"/>
													</div>
													<h3 class="font-weight-bold">Maria Jones</h3>
													<span class="position d-block mb-3">CEO, Co-Founder, XYZ Inc.</span>
												</div>
											</div>

										</div>
									</div>
    </div>
    
</OwlCarousel>
</div>
        </div>
    )
}



export default Testimonial;